<script>
import { mapState, mapActions } from 'vuex';
/* components */
// import TermsFull from '@/components/TermsFull';
/* tools */
import {} from '@/scripts/utils';
import {
  getGame,
  getGameInstructions,
  getGameTypes,
} from '@/scripts/api/games';
import { getGameConnectionsInfo } from '@/scripts/api/connections';
import { mobile } from '@/scripts/computed';

export default {
  name: 'Test',
  components: {
    // TermsFull,
  },
  props: {
    show: {
      type: Boolean,
      default: !false,
    },
  },
  watch: {},
  data() {
    return {
      testWidthFits: null,
    };
  },
  computed: {
    ...mapState(['user', 'games']),
    mobile,
  },
  created() {
    const { NODE_ENV: env } = process.env;
    const prod = env !== 'development';
    const urlParams = new URLSearchParams(window.location.search);
    const force = urlParams.get('force');

    this.prod = prod;

    if (this.prod && !force) this.$router.push('/');
  },
  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
  mounted() {
    /*  */
    window.addEventListener('resize', this.resize);
    this.resize();
    /*  */
  },
  methods: {
    ...mapActions({}),
    resize() {
      const { innerWidth } = window;
      const { testWidth } = this.$refs;
      const result = innerWidth > testWidth.offsetWidth;

      this.testWidthFits = result;
    },
    apiTest() {
      const { games } = this;

      /* apiTest */
      (() => {
        const getConnectionsRequests = [];
        const getGameRequests = [];
        const getGameTypesRequests = [];
        const getGameInstructionsRequests = [];

        const setup = {
          makeConnectionsRequests: true,
          makeGameRequests: !true,
          makeGameInstructionsRequests: !true,
          makeGameTypesRequests: !true,
        };

        /* ... . .-. --. . / --.. .... ..- .-. .- ...- .-.. . ...- */

        games.forEach(game => {
          const { id, platforms } = game;

          if (setup.makeConnectionsRequests) {
            getConnectionsRequests.push(getGameConnectionsInfo(id));
          }

          if (setup.makeGameRequests) {
            getGameRequests.push(getGame(id));
          }

          if (setup.makeGameTypesRequests) {
            getGameTypesRequests.push(getGameTypes(id));
          }

          if (setup.makeGameInstructionsRequests) {
            platforms.forEach(platform => {
              getGameInstructionsRequests.push(
                getGameInstructions(id, platform.id).then(res => {
                  /* console.log(id, platform.id, res) */

                  return res;
                })
              );
            });
          }
        });

        /* ... . .-. --. . / --.. .... ..- .-. .- ...- .-.. . ...- */

        if (setup.makeConnectionsRequests)
          Promise.all(getConnectionsRequests).then(all => {
            this.games.forEach(({ id }, i) => {
              const res = all[i];

              console.log(id, ...res);
            });
          });

        if (setup.makeGameRequests)
          Promise.all(getGameRequests).then(console.log);

        if (setup.makeGameTypesRequests)
          Promise.all(getGameInstructionsRequests).then(console.log);

        if (setup.makeGameInstructionsRequests)
          Promise.all(getGameTypesRequests).then(arr => {
            console.log(arr);

            arr.forEach(({ items }) => {
              items.forEach(({ dashboardFields, leaderboardFields }) => {
                dashboardFields.forEach(({ statsField }) => {
                  console.log(statsField);
                });
                leaderboardFields.forEach(({ statsField }) => {
                  console.log(statsField);
                });
              });
            });
          });
      })();
    },
  },
};
</script>

<template>
  <div class="root" v-if="show">
    <div :class="['mobile-test', $mq]">js mobile-test</div>
    <div :class="['mobile-test', 'css-only']">css mobile-test</div>
    <div
      class="outer"
      v-html="
        `outer<div class=inner>inner third parties HTML</div><div class=fake>fake</div>`
      "
    ></div>
    <!-- <div :class="['mobile-test', 'mobile']">force mobile</div>
    <div :class="['mobile-test', 'desktop']">force desktop</div> -->
    <!-- <TermsFull></TermsFull> -->
    <div
      :class="{ 'test-width': true, mobile, 'fit-width': testWidthFits }"
      ref="testWidth"
    >
      {{
        `block-width 1100px ant it is ${
          testWidthFits ? '' : 'DO NOT'
        } fully fits into screen width`
      }}
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.root {
  background-color: #aabbcc;
}

.test-width {
  background-color: rgba(0, 109, 28, 0.2);
  height: 100px;
  width: 1100px;

  &.mobile {
    background-color: rgba(247, 0, 28, 0.2);
  }

  &.fit-width {
    background-color: rgba(247, 109, 0, 0.2);
  }
}

.mobile-test {
  color: #f00;
}
.mobile {
  background-color: #22aacc;
}
.desktop {
  background-color: #aacc22;
}

@media (max-width: $mobile) {
  .css-only {
    background-color: #aa22ff;
  }
}

@media (min-width: $desktop) {
  .css-only {
    background-color: #aa2200;
  }
}

.outer {
  background-color: #f00;

  ::v-deep .inner {
    width: 300px;
    height: 60px;
    background-color: #00ff00;
  }
}
</style>
